import { gsap } from 'gsap'

export default function moveClouds(body) {
  let request = null
  let mouse = { x: 0, y: 0 }
  let cx = window.innerWidth / 2
  let cy = window.innerHeight / 2

  body.mousemove(function(event) {
    mouse.x = event.pageX
    mouse.y = event.pageY

    cancelAnimationFrame(request)
    request = requestAnimationFrame(update)
  });

  function update() {
    let dx = mouse.x - cx
    let dy = mouse.y - cy
  
    let tiltx = (dy / cy)
    let tilty = - (dx / cx)
    let radius = Math.sqrt(Math.pow(tiltx,2) + Math.pow(tilty,2))
    let degree = (radius * 5)
    
    gsap.to('.clouds', {
      rotationX: degree * tiltx,
      rotationY: degree * tilty,
      ease: 'power2.out',
      duration: 1
    });
  }

  $(window).resize(function() {
    cx = window.innerWidth / 2;
    cy = window.innerHeight / 2;
  });	
}